import { IHttpApi, FetchResponse } from '@cian/http-api';
import { ILogger } from '@cian/logger';

import { ResponseError } from 'shared/errors/ResponseError';
import {
  fetchTrackSpecialPromoShow as fetchTrackSpecialPromoShowPublic,
  TTrackSpecialPromoShowRequest,
  TTrackSpecialPromoShowResponse,
} from 'shared/repositories/special-promos-exclusive/v1/track-special-promo-show';

interface IFetchTrackSpecialPromoShowParams {
  httpApi: IHttpApi;
  logger: ILogger;
  parameters: TTrackSpecialPromoShowRequest;
}

export const fetchTrackSpecialPromoShow = async ({
  httpApi,
  logger,
  parameters,
}: IFetchTrackSpecialPromoShowParams): Promise<void> => {
  try {
    const { response, statusCode }: FetchResponse<TTrackSpecialPromoShowResponse> =
      await fetchTrackSpecialPromoShowPublic({
        httpApi,
        parameters,
      });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'src/shared/services/fetchTrackSpecialPromoShow/service.ts',
        message: response.message || 'Ошибка при отправке события показа баннера',
        details: {
          error: JSON.stringify(response.errors),
        },
      });
    }
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/fetchTrackSpecialPromoShow/service.ts',
      message: error.message || 'Ошибка при отправке события показа баннера',
    });
  }
};
